import React from 'react';
import { FooterStyles } from '../Styles/FooterStyles';

export default function Footer() {
  return (
    <FooterStyles>
      <h5>All Rights reserved</h5>

      <h5>Special Thanks to Mapbox 2022</h5>
    </FooterStyles>
  );
}
